import request from '@/utils/request';


export async function uploadRF(payload) {
  return request(`/iwms-account/account/rf/uploadRF`, {
    method: 'POST',
    body: payload,
  });
}

export async function query(payload) {
  return request(`/iwms-account/account/rf/query/rf`, {
    method: 'POST',
    body: payload,
  });
}

export async function queryByUpperUuids(payload) {
  return request(`/iwms-account/account/org/queryByUpperUuids?orgType=${payload.orgType}`, {
    method: 'POST',
    body: payload.upperUuids,
  })
}
